export default {
  setSales(state, payload) {
    state.sales = payload;
  },
  addSale(state, payload) {
    state.sales.push(payload);
  }
}
